import React from 'react';
import { createRoot } from 'react-dom/client';
import { initialValues } from './partials/settings/default-values';
import { SettingsForm } from './partials/settings/SettingsForm';

export default function loadCommands(editor, options) {
  const {Commands} = editor;

  const {
    modalTitle,
    componentKey,
    commands,
    formElementID
  } = options;

  const configureCommand = {
    componentKey,
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const {target} = this;

      const componentData = target.get(componentKey) || initialValues;
      let content = `<div id="${formElementID}"></div>`;

      editor.Modal
        .open({title: modalTitle, content})
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));

      const reactRootElement = document.getElementById(formElementID);

      this._reactRoot = createRoot(reactRootElement);
      this._reactRoot.render(<SettingsForm
                        defaultValues={componentData}
                        submitHandler={(formValues) => {
                          const {editor, target} = this;

                          target.addAttributes({'settings': formValues});
                          target.set(componentKey, formValues);

                          editor.Modal.close();
                        }}/>);
    },
    stop() {
      editor.Modal.close();
      if (this._reactRoot) {
        this._reactRoot.unmount();
        this._reactRoot = null;
      }
    }
  };

  Commands.add(commands.configure, configureCommand);
}
